import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
// import About from "./components/About";
import Contact from "./components/Contact";
import ReasonsToAutomate from "./components/ReasonsToAutomate";
import CostSavingBenefits from "./components/CostSavingBenefits";
import { Helmet } from 'react-helmet'


function Home() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div>
        <div className="w-48 md:w-[300px] float-right ml-2 mb-2 pt-[10px] pr-[10px]">
          <video           
            autoPlay  
            loop 
            muted
            playsInline           // ← Critical for iOS!
            preload="auto"        // or "metadata" — try both
           webkit-playsinline={true.toString()}    // Old iOS fallback (still helps sometimes)
            className="w-full h-auto"
            style={{ 
              borderRadius: '10px',
              opacity: 0.8
             }}
          >
            <source src={require('./videos/csoflow_vid.mp4')} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* <h2 className="text-3xl font-bold mb-2">Welcome to csoautomation</h2> */}
        <div className="bg-white bg-opacity-10 p-8 rounded-lg mb-12">
          <h2 className="text-xl font-bold mb-2">Capture, Simplify & Optimize Your Process Flow™</h2>
          <h2 className="text-base font-bold mb-2">We deliver targeted automation solutions that capture, simplify, and optimize your most time-intensive business and engineering processes</h2>
          <p className="text-sm">CSOAUTOMATION™ partners with organizations to develop, refine, and scale business and engineering processes, enhancing operational efficiency and profitability. Through targeted automation and deep engineering expertise, we enable clients to streamline operations, eliminate inefficiencies, and achieve sustainable growth.</p>

          <p className="text-sm mt-2"></p>
          <p className="text-sm">We specialize in automating repetitive tasks through seamless data accumulation and efficient output generation. Whether managing complex engineering workflows or routine business operations, CSOAUTOMATION™ delivers customized solutions that reduce time requirements, minimize errors, and enhance productivity. Our experience has shown that custom desktop and mobile applications, tailored precisely to your business needs, deliver exceptional effectiveness.</p>
          
          <p className="text-sm mt-2"></p>
          <h2 className="text-xl font-bold mb-2">Examples Of What We Do</h2>
          <ul className="list-none pl-5 text-sm space-y-1">
            <li><strong>Custom desktop & web applications</strong> – Automating spreadsheet and database workflows</li>
            <li><strong>Integrated online business platforms</strong> – Invoicing, inventory control, sales tracking, and CRM</li>
            <li><strong>Automated PDF generation</strong> – Professional document and report creation from structured data</li>
            <li><strong>Multi-source report automation</strong> – Generation and distribution from diverse data inputs</li>
            <li><strong>Complete inventory management systems</strong> – Full tracking and control solutions</li>
            <li><strong>Tailored workflow & process automation</strong> – Custom business process management systems</li>
            <li><strong>Data integration & synchronization tools</strong> – Seamless ETL (extract, transform, load) capabilities</li>
            <li><strong>Automated communication workflows</strong> – Email notifications, alerts, and triggers</li>
            <li><strong>Task scheduling & reminder applications</strong> – Prioritization and follow-up automation</li>
            <li><strong>Business intelligence tools</strong> – Data analytics dashboards and visualization for actionable insights</li>
          </ul>

          <p className="text-sm mt-2"></p>
          <h2 className="text-xl font-bold mb-2">Our Approach</h2>
          <p className="text-sm mt-2">We employ a comprehensive methodology grounded in broad engineering experience. Our process begins with software-driven automation to address time-intensive tasks, followed by targeted analysis and reduction of mechanical inefficiencies where applicable. Share your automation objectives with us, and we will develop a tailored plan to achieve them.</p>

          <p className="text-sm mt-2"></p>
          <h2 className="text-xl font-bold mb-2">Our Process</h2>
          <ul className="list-none pl-5 text-sm space-y-1">
            <li>Capture: We systematically collect and organize relevant data for comprehensive analysis.</li>
            <li>Optimize: Applying specialized expertise to the captured data, we identify and eliminate inefficiencies.</li>
            <li>Simplify: We refine optimized processes into streamlined, cost-effective workflows.</li>
          </ul>

          <p className="text-sm mt-2"></p>
          <h2 className="text-xl font-bold mb-2">Key Benefits</h2>
          <ul className="list-none pl-5 text-sm space-y-1">
            <li>Reduced Overhead: Automated data collection and organization from diverse sources, minimizing manual effort.</li>
            <li>Enhanced Workflows: Conversion of complex processes into efficient, intuitive systems requiring minimal ongoing intervention.</li>
            <li>Improved Financial Performance: Resolution of bottlenecks, automation of routine tasks, and scalable operations that directly support profitability.</li>
          </ul>

          <p className="text-sm mt-2">Discover how CSOAUTOMATION™ can refine your processes and strengthen your organization’s long-term success. <Link to="/contact" className="hover:opacity-80 underline">Contact Us</Link> today to discuss your specific needs.</p>
        </div>
      </div>
    </div>
  );
}

function App() {

  const siteBase = process.env.REACT_APP_API_URL;  // simple reuse
  // Builds full current URL (updates on route change via window.location)
  const canonicalUrl = `${siteBase}${window.location.pathname}${window.location.search}`;

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />        
        <title>CSOAUTOMATION™ - Home</title>        
      </Helmet>
      <BrowserRouter>
        <div 
          className="flex flex-col min-h-screen text-white bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${require('./images/bg_csoflow.png')})`,
            backgroundAttachment: 'fixed'
          }}
        >
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reasons-to-automate" element={<ReasonsToAutomate />} />
              <Route path="/cost-saving-benefits" element={<CostSavingBenefits />} />
              {/* <Route path="/about" element={<About />} /> */}
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;